import Header from "../global/header";
import Footer from "../global/footer";
import Breadcrumbs from "../breadcrumbs";
import AuthorV2 from "../authorv2";

const Author = ({headerv3, footer}) => {
  const {menuv2} = footer;

  return (
    <>
      <Header header={headerv3} />
      <Breadcrumbs isBg="yes" title="Meet the Author" />
      <AuthorV2 isBg="" />
      <Footer isBg="yes" menu={menuv2} />
    </>
  );
};

export default Author;
